export class NativeStreamMapTransformColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "expr",
            "baseName": "expr",
            "type": "string",
            "format": ""
        },
        {
            "name": "overwrite",
            "baseName": "overwrite",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamMapOutputKind",
            "format": ""
        },
        {
            "name": "keys",
            "baseName": "keys",
            "type": "NativeStreamMapKeyType",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "NativeStreamOutputType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamMapTransformColumn.attributeTypeMap;
    }
    constructor() {
    }
}
